import { Component, Input, OnInit } from '@angular/core';
import { ISimpleData } from '../../../../../shared/models/simpleData.model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralSettingsService } from '../../../../../services/general-settings.service';
import { ToastService } from '../../../../../services/toast.service';
import { AddEditDelayCodeDialogComponent } from '../add-edit-delay-code-dialog/add-edit-delay-code-dialog.component';
import { take } from 'rxjs/operators';
import { DeleteModalComponent } from '../../../../../shared/components/delete-modal/delete-modal.component';
import { AddEditMeasurementUnitsDialogComponent } from '../add-edit-measurement-units-dialog/add-edit-measurement-units-dialog.component';

@Component({
  selector: 'app-manage-measurement-units-dialog',
  templateUrl: './manage-measurement-units-dialog.component.html',
  styleUrls: ['./manage-measurement-units-dialog.component.scss']
})
export class ManageMeasurementUnitsDialogComponent implements OnInit {

  @Input() title?: string;
  @Input() measurementUnits?: { [p: number]: ISimpleData };
  @Input() readonly = true;
  selected?: string | any;

  constructor(private modalService: NgbModal, private activeModal: NgbActiveModal, private generalSettingsService: GeneralSettingsService, private toastService: ToastService) {
  }

  ngOnInit() {
    this.fetchMeasurementUnits();
  }

  doAdd() {
    const modalRef = this.modalService.open(AddEditMeasurementUnitsDialogComponent, { size: 'lg'});
    modalRef.componentInstance.title = 'Add Measurement unit';
    modalRef.dismissed.pipe(take(1)).subscribe(() => {
      this.fetchMeasurementUnits();
    })
  }

  doEdit(item: string | any) {
    if (!item) {
      return;
    }
    const modalRef = this.modalService.open(AddEditMeasurementUnitsDialogComponent, { size: 'lg'});
    modalRef.componentInstance.title = 'Edit Measurement unit';
    modalRef.componentInstance.measurementUnit = this.measurementUnits[item];
    modalRef.dismissed.pipe(take(1)).subscribe(() => {
      this.fetchMeasurementUnits();
    })
  }

  doDelete(item: string | any) {
    if (!item) {
      return;
    }
    const modalRef = this.modalService.open(DeleteModalComponent);
    modalRef.componentInstance.term = 'Measurement unit ' + this.measurementUnits[item].code;

    modalRef.componentInstance.startDeletion.pipe(take(1)).subscribe(() => {
      this.generalSettingsService.deleteMeasurementUnit(item).subscribe((result) => {
        if(result) {
          this.toastService.showSuccess("The measurement unit has been deleted.");
          this.fetchMeasurementUnits();
        }
      });
    });

  }

  fetchMeasurementUnits() {
    this.generalSettingsService.getMeasurementUnits().subscribe((result) => {
      this.measurementUnits = {};
      for (const passengerClass of result) {
        this.measurementUnits[passengerClass.id] = passengerClass;
      }
    });
  }

  closeModal() {
    this.activeModal.dismiss();
  }

}
